import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HostnameService {

    isAppDomain(): boolean {
        if (!environment.production) return true;
        const hostname = window.location.hostname;
        return hostname.startsWith('app.');
    }

    isLandingDomain(): boolean {
        if (!environment.production) return true;
        return !this.isAppDomain();
    }

    getAppUrl(path: string): string {
        if (!environment.appDomain) return path;
        return `${environment.appDomain}${path}`;
    }
}
